<template>
  <div class="z-40 xl:z-60 ">
    <div
      :class="`text-${theme}`"
      class="lg:ml-8 font-bold no-underline cursor-pointer flex hover:underline "
      @click="show_city = true"
    >
     <font-awesome-icon class="mr-2 " :class="`${cityColor}`" :icon="['far', 'map-marker-alt']"></font-awesome-icon>
      <p class="z-50 pl-1  text-sm " :class="`${cityColor}`"> {{city || 'Выбрать город'}}</p>
    </div>
    <SelectCity
      v-if="city_selector"
      class="absolute z-50 lg:flex xl:flex ml-8 shadow-md hidden"
      @close="close"
      @city_link="fill_city"
      @open_list="show_city = true"
    ></SelectCity>
    <SelectCityMobile
            v-if="city_selector_mobile"
            class="z-50 lg:hidden"
            @close="close"
            @city_link="fill_city"
            @open_list="show_city = true"
    >
    </SelectCityMobile>
    <CityList
      v-if="show_city"
      @close="close_modal"
      @add_social_link="fill_city"
    ></CityList>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import mobileDetect from '../../mixins/isMobile';
import SelectCity from './stub_city_select.vue';
import CityList from './city_list.vue';
import base from '@/clients/base';
import SelectCityMobile from './stub_city_select_mobile';

export default {
  mixins: [mobileDetect],
  name: 'StubCity',
  props: {
    theme: {
      type: String,
      default: 'white',
    },
    cityColor: {
      type: String,
      default: 'white',
    },
  },
  components: {
    SelectCityMobile,
    SelectCity,
    CityList,
  },
  created() {
    if (!(this.city && this.cityContent) && this.$route.query.gameId && this.$route.query.city) {
      // this.citySelect(this.$route.query.city, this.$route.query.gameId);
    } else {
      if (this.isPhone === 'desktop') {
        if (this.city && this.cityContent) {
          this.city_selector = false;
        } else {
          this.city_selector = !this.$store.getters.cityProps.first_init;
        }
      }
      if (this.isPhone === 'mobile') {
        if (this.city && this.cityContent) {
          this.city_selector = false;
        } else {
          this.city_selector_mobile = !this.$store.getters.cityProps.first_init;
        }
      }
    }
  },
  data() {
    return {
      show_city: false,
      city_selector: false,
      city_selector_mobile: false,
    };
  },
  methods: {
    ...mapActions(['selectCityInfo']),
    ...mapActions(['setApplicationIsFetched']),
    citySelect(cityId, gameId) {
      base.get(`/locations/cities/${cityId}`)
        .then((response) => {
          this.selectCityInfo(response.data);
          this.$router.go(`/?gameId=${gameId}`);
        });
    },
    close() {
      this.city_selector = false;
      this.city_selector_mobile = false;
    },
    fill_city($event) {
      this.close_modal();
    },

    close_modal() {
      this.show_city = false;
    },
  },
  computed: {
    isPhone() {
      return this.isMobile;
    },
    city() {
      return this.$store.getters.cityProps.city || '';
    },
    cityContent() {
      return this.$store.getters.cityProps.is_able_to_order_offline_games || '';
    },
    link() {
      return this.$store.getters.cityProps.social_network_link || '';
    },
  },
  watch: {
    show_city() {
      if (this.show_city) this.city_selector = false; this.city_selector_mobile = false;
    },
    link() {
      this.$emit('city_link', { link: this.link });
    },
    city_selector() {
      this.$emit('city_selector', { city_selector: this.city_selector });
    },
    city_selector_mobile() {
      this.$emit('city_selector', { city_selector_mobile: this.city_selector_mobile });
    },
  },
};
</script>


<style lang="less" scoped>
  @media (max-width: 767px) {
    .hide-element {
      display: none;
    }
  }
p {
  font-family: "Montserrat", sans-serif;
}
</style>
